import React, { useState } from "react";


const FunderLogin = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        rememberMe: true,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Submitted:", formData);
        // API call here
    };

    return (
        <main
            className="d-flex w-100"
            style={{
                minHeight: "100vh",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
                padding: "1rem",
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5">
                        <div className="text-center mb-4">
                            <h1 className="h2">Welcome</h1>
                            <p className="lead">Sign in to your account to continue</p>
                        </div>

                        <div className="card shadow-sm">
                            <div className="card-body">
                                <div className="m-sm-3">
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label className="form-label">Email</label>
                                            <input
                                                className="form-control form-control-lg"
                                                type="email"
                                                name="email"
                                                placeholder="Enter your email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="mb-3">
                                            <label className="form-label">Password</label>
                                            <input
                                                className="form-control form-control-lg"
                                                type="password"
                                                name="password"
                                                placeholder="Enter your password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>

                                        <div className="form-check mb-3">
                                            <input
                                                id="customControlInline"
                                                type="checkbox"
                                                className="form-check-input"
                                                name="rememberMe"
                                                checked={formData.rememberMe}
                                                onChange={handleChange}
                                            />
                                            <label
                                                className="form-check-label text-small"
                                                htmlFor="customControlInline"
                                            >
                                                Remember me
                                            </label>
                                        </div>

                                        <div className="d-grid gap-2 mt-3">
                                            <button
                                                type="submit"
                                                className="btn btn-lg btn-primary"
                                            >
                                                Sign in
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </main>
    );
};

export default FunderLogin;
